// extracted by mini-css-extract-plugin
module.exports = {"chart":"BarChart_chart__ZI9KV","bar":"BarChart_bar__p40mL"};